import { render, staticRenderFns } from "./addTask.vue?vue&type=template&id=fe82dd8a&scoped=true&"
import script from "./addTask.vue?vue&type=script&lang=js&"
export * from "./addTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe82dd8a",
  null
  
)

export default component.exports